import { render, staticRenderFns } from "./FormUploadLeaseDocs.vue?vue&type=template&id=3afb6e74&"
import script from "./FormUploadLeaseDocs.vue?vue&type=script&lang=js&"
export * from "./FormUploadLeaseDocs.vue?vue&type=script&lang=js&"
import style0 from "./FormUploadLeaseDocs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports